import axios from 'axios';

class Sponsorships {
    constructor() {
        if (document.querySelector('.js-sponsorship')) {
            this.sponsorships = document.getElementsByClassName('js-sponsorships-select');
            this.sponsorshipsQuantity = document.getElementsByClassName('js-sponsorships-quantity');
            this.totalPrice = null;
            if (Array.from(this.sponsorships).length > 0) {
                this.bindChangeSponsorships();
                this.bindChangeSponsorshipsQuantity();
                this.bindClickSponsorships();
                Sponsorships.toggleBenefits();
                this.getTotalPrice();
                Sponsorships.setCheckedBox();
            }
        }
    }

    bindChangeSponsorships() {
        Array.from(this.sponsorships).forEach((item) => {
            item.addEventListener('change', () => {
                if (item.resetFalse) {
                    item.checked = false;
                }
                Sponsorships.toggleBenefits();
                this.getTotalPrice();
                Sponsorships.setCheckedBox();
            });
        });
    }

    bindChangeSponsorshipsQuantity() {
        Array.from(this.sponsorshipsQuantity).forEach((item) => {
            item.addEventListener('change', () => {
                this.getTotalPrice();
            });
        });
    }

    bindClickSponsorships() {
        Array.from(this.sponsorships).forEach((item) => {
            item.addEventListener('focus', () => {
                item.resetFalse = !!(item.checked);
                if (item.checked) {
                    item.checked = false;
                }
            });
        });
    }

    static toggleBenefits() {
        document.querySelectorAll('[data-target-benefits]').forEach((item) => {
            if (!item.checked && document.querySelector(item.dataset.targetBenefits)) {
                document.querySelector(item.dataset.targetBenefits).classList.add('hidden');
                Array.from(document.querySelectorAll(`${item.dataset.targetBenefits} input`)).forEach((input) => {
                    input.checked = false;
                    input.required = false;
                    if (input.classList.contains('empty')) {
                        input.checked = true;
                    }
                });
            } else if (document.querySelector(item.dataset.targetBenefits)) {
                document.querySelector(item.dataset.targetBenefits).classList.remove('hidden');
                Array.from(document.querySelectorAll(`${item.dataset.targetBenefits} input`)).forEach((input) => {
                    input.required = true;
                    if (Boolean(input.dataset.allowMultiple) && document.querySelector(`${item.dataset.targetBenefits} input:checked`)) {
                        input.required = false;
                    }
                });
            }
        });
    }

    getTotalPrice() {
        this.totalPrice = 0;
        Array.from(this.sponsorships).forEach((item) => {
            const box = item.closest('.box');
            const quantity = box.querySelector('.js-sponsorships-quantity');
            if (item.checked && item.dataset.price) {
                if (quantity) {
                    this.totalPrice += parseFloat(item.dataset.price) * quantity.value;
                } else {
                    this.totalPrice += parseFloat(item.dataset.price);
                }
            }
        });
        if (document.querySelector('#js-value-total-price')) {
            axios.get(`/formatPrice/${this.totalPrice}`).then((result) => {
                document.querySelector('#js-value-total-price').innerHTML = result.data;
            });
        }
    }

    static setCheckedBox() {
        const inputs = document.getElementsByTagName('input');
        if (inputs) {
            Array.from(inputs).forEach((item) => {
                const box = item.closest('.box');
                if (box) {
                    const quantity = box.querySelector('.js-sponsorships-quantity');
                    if (item.checked) {
                        box.classList.add('checked');
                        if (quantity) {
                            quantity.classList.remove('hidden');
                        }
                    } else {
                        box.classList.remove('checked');
                        if (quantity) {
                            quantity.classList.add('hidden');
                        }
                    }
                }
            });
        }
    }
}

export default Sponsorships;
